import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from 'react'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'

const RangePickeComponent = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker calendars={1} />
    </LocalizationProvider>
  )
}

export default RangePickeComponent
